var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-header-container"},[_c('p',{staticClass:"icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }